import MapComponent from './mapComponent';

export default MapComponent;
